import { useAtom } from "jotai";
import { venueSearchParamsAtom } from "./atoms";

export function useHomeSearchParams() {
  const [homeSearchParams, setHomeSearchParams] = useAtom(
    venueSearchParamsAtom
  );
  return { homeSearchParams, setHomeSearchParams };
}
